// extracted by mini-css-extract-plugin
module.exports = {"button":"OrderByPanel_button__jK2qO","selected":"OrderByPanel_selected__jeyS6","label":"OrderByPanel_label__IRMMD"};